import { render, staticRenderFns } from "./TBAllianceAuthorization.vue?vue&type=template&id=76eb62fd"
import script from "./TBAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./TBAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76eb62fd')) {
      api.createRecord('76eb62fd', component.options)
    } else {
      api.reload('76eb62fd', component.options)
    }
    module.hot.accept("./TBAllianceAuthorization.vue?vue&type=template&id=76eb62fd", function () {
      api.rerender('76eb62fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/TBAllianceAuthorization.vue"
export default component.exports